/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Ref,
  Ref$inboundSchema,
  Ref$Outbound,
  Ref$outboundSchema,
} from "./ref.js";

/**
 * The configuration of the animatic for a condenser.
 */
export type AnimaticCondenserConfig = {
  /**
   * The labels for the fans.
   */
  fanLabels?: Array<string> | undefined;
  /**
   * The references used to determine which fans are on.
   */
  fanOnRefs: Array<Ref>;
};

/** @internal */
export const AnimaticCondenserConfig$inboundSchema: z.ZodType<
  AnimaticCondenserConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  fan_labels: types.optional(z.array(types.string())),
  fan_on_refs: z.array(Ref$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "fan_labels": "fanLabels",
    "fan_on_refs": "fanOnRefs",
  });
});
/** @internal */
export type AnimaticCondenserConfig$Outbound = {
  fan_labels?: Array<string> | undefined;
  fan_on_refs: Array<Ref$Outbound>;
};

/** @internal */
export const AnimaticCondenserConfig$outboundSchema: z.ZodType<
  AnimaticCondenserConfig$Outbound,
  z.ZodTypeDef,
  AnimaticCondenserConfig
> = z.object({
  fanLabels: z.array(z.string()).optional(),
  fanOnRefs: z.array(Ref$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    fanLabels: "fan_labels",
    fanOnRefs: "fan_on_refs",
  });
});

export function animaticCondenserConfigToJSON(
  animaticCondenserConfig: AnimaticCondenserConfig,
): string {
  return JSON.stringify(
    AnimaticCondenserConfig$outboundSchema.parse(animaticCondenserConfig),
  );
}
export function animaticCondenserConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticCondenserConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticCondenserConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticCondenserConfig' from JSON`,
  );
}
